import React from 'react';

const bottom = () => {

	return (
		<div className="B13-quick-links-login__view">
			<h2 className="B13-quick-links-login__title">
				New to Innophos?
			</h2>
			<a
				className="B13-quick-links-login__button btn btn--secondary btn--inverted"
				href="/customer-center"
			>
				Create an account
				<span className="btn__arrow-angle" />
			</a>
		</div>
	);
};

export default bottom;
